import { ActionIcon, Center, createStyles, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconX } from "@tabler/icons-react";
import { CSSProperties } from "react";

const useStyles = createStyles({
  fullscreenImage: {
    width: "70%",
  },
  galleryImage: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    borderRadius: 12,
  },
  modalContent: {
    background: "rgba(0, 0, 0, 0.5) !important",
    backdropFilter: "blur(4px)",
    padding: "0px !important",
  },

  modalHeader: {
    background: "none !important",
    justifyContent: "flex-end",
    margin: 0,
    padding: 0,
    paddingTop: 16,
	paddingRight: 16,
    height: "auto",
  },
  modalBody: {
    height: "90vh",
  },
});

interface IFullscreenImageProps {
  src: string;
  alt: string;
  style?: CSSProperties;
  className?: string;
}

export default function FullscreenImage({
  alt,
  src,
  className,
  style,
}: IFullscreenImageProps) {
  const [isOpened, { open, close }] = useDisclosure(false);
  const { classes } = useStyles();

  return (
    <>
      <img
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            open();
          }
        }}
        aria-label={`Imagine: ${alt}`}
        onClick={open}
        src={src}
        alt={alt}
        style={{
          cursor: "zoom-in",
          outline: "none",
          ...style,
        }}
        className={className}
      />

      <Modal
        transitionProps={{
          transition: "fade",
        }}
        title={
          <ActionIcon onClick={close} variant="transparent" size="xl" c="white">
            <IconX />
          </ActionIcon>
        }
        overlayProps={{
          bg: "rgba(0, 0, 0, 0.5)",
        }}
        lockScroll={false}
        closeOnEscape
        classNames={{
          content: classes.modalContent,
          header: classes.modalHeader,
          body: classes.modalBody,
        }}
        opened={isOpened}
        onClose={close}
        fullScreen
        zIndex={2000}
        withCloseButton={false}
      >
        <Center onClick={close} h="100%">
          <img
            style={{
              // width: "100%",
              objectFit: "contain",
              maxHeight: "100%",
            }}
            src={src}
            alt={alt}
            className={classes.fullscreenImage}
          />
        </Center>
      </Modal>
    </>
  );
}
